import vue from "vue";
import {getBannerPage, addBanner, editBanner, deleteBanner, getBannerId} from '../../../services/banner'

const state = {
  addVisible: false,
  editVisible: false,
  dataPages: [],
  detailsData: [],
  fileUrl: '',
};

const getters = {
  addVisible: () => state.addVisible,
  editVisible: () => state.editVisible,
  dataPages: () => state.dataPages,
  detailsData: () => state.detailsData,
  fileUrl: () => state.fileUrl,
};

const actions = {
  //获取banner图分页
  getBannerPage({commit, dispatch}, objc) {
    getBannerPage(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data});
      }
    })
  },

  //根据id获取详情
  getBannerId({commit, dispatch}, objc) {
    getBannerId(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'detailsData', update: res.data});
      }
    })
  },

  //添加banner图
  addBanner({commit, dispatch}, objc) {
    addBanner(objc.params).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'addVisible', update: false});
        commit('common/updateState', {state: 'fileUrl', update: null},{root: true});
        dispatch('getBannerPage');
        if(objc.ref){
          objc.ref()
        }
      }
    })
  },

  //编辑banner图
  editBanner({commit, dispatch}, objc) {
    editBanner(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'editVisible', update: false});
        dispatch('getBannerPage');
      }
    })
  },

  //删除banner图
  deleteBanner({commit, dispatch}, objc) {
    deleteBanner(objc).then((res) => {
      if (res.code === 0) {
        dispatch('getBannerPage');
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/banner/modules/banner.js